import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const SETTINGS_LINKS_SCHEMA = Object.freeze({
  PROFILE_URL: '',
});
export const RECORD = generateSchema(SETTINGS_LINKS_SCHEMA);
export const KEYS: any = generateKeys(SETTINGS_LINKS_SCHEMA);

export class SettingsLinks extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get profileUrl(): string {
    return this.get(KEYS.PROFILE_URL);
  }
}
